export default class Account {
    name?: string
    givenName?: string
    familyName?: string
    avatarUrl?: string
    email?: string
    static unmarshal(json: any): Account | undefined {
        if (!json) {
            return undefined
        }
        var account = Object.assign(new Account(), json)
        return account
    }
}
